import { createStore } from 'idb-keyval';

const informationStore = createStore('MRAT_PDF_DB', 'InfoDocuments');

export default informationStore;
